<template>
    <b-alert show variant="danger">
        <div class="d-flex align-items-center">
            <i class="fas fa-exclamation-triangle"></i>
            <div class="pl-3">
                <p class="font-weight-bold mb-0 text-uppercase">
                    {{ $t('error.EMAIL_EXISTS') }}
                </p>
                <span>{{ $t('auth.google_login.email_existed') }}</span>
            </div>
        </div>
    </b-alert>
</template>

<script>
export default {
    name: 'EmailExistedAlert',
};
</script>
